import { configureStore } from '@reduxjs/toolkit';

import serverState from'./serverStateReducers';
import appStates from './appStateReducers';
import dataStates from './dataStateReducers';
import activityStates from "./activityStateReducers";
// import compStates from './compStateReducers';

export default configureStore({
  reducer: {
    serverState,
    appStates,
	dataStates,
	activityStates
  },
});
